import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import type { MachineConfiguration, SernumsInitialState, SernumsResponse } from "./sernums.interface";
import { RootState } from "../store";
import { handleAxiosError } from "../../partials/utils/utils";
import { sernumsService } from "./sernums.service";

const inkTextfields = [
  { id: "cleaningFluid", placeholder: "Cleaning Fluid", value: "", label: "Tank1" },
  { id: "ink1", placeholder: "Ink1", value: "", label: "Tank2" },
  { id: "ink2", placeholder: "Ink2", value: "", label: "Tank3" },
  { id: "ink3", placeholder: "Ink3", value: "", label: "Tank4" },
  { id: "ink4", placeholder: "Ink4", value: "", label: "Tank5" }
];
// THIS IS THE UI OF THE CHECKBOXES
export const initialState: SernumsInitialState = {
  sernums: {
    STUDIO: "",
    FOILSAVIN: "",
    HDUVLED: "",
    BARCODE: "",
    ART: "",
    CC: "",
    BRAILE: "",
    CRYSTAL: "",
    PRESSHASETH4G: "",
    VPA: "",
    GREYSCALE: "",
    UNCOATED: "",
    SHD: "",
    MULTILAY: "",
    "3DSCULP": "",
    CRYSTALHD: "",
    BRAILEHD: "",
    OPACALIB: "",
    CURLYSHET: "",
    HASVPA: "",
    // W2PTYPE: "",
    // UIPRESSTYPEDES: "",
    // FOILERTYPE: "",
    MAAS: "",
    SHBI: "",
    STATICCAMERA: "",
    FOILERHMI: "",
    // MAESTROEMAIL: "",
    // MAESTROPASS: "",
    // PRESSTYPEDES: "",
    // CAMERATYPE: "",
    INHOUSEPRESS: "",
    // WINID: "",
    // CDES: "",
     FOIL:"",
    // SHIPDATE:""
    // PASSGENCOMP: "",
    // PASSGENCOMPDATE: ""
    IONIZER: "",
    RFID: "",
    VMCOUNT: "",
    STORAGEWINID: ""
    // W2PWINID: "",
    // STUDIOID: ""
  },
  machineConfiguration: {
    machineType: "",
    cameraType: "",
    w2pType:"",
    foilerType:"",
  },
  encodedPassword: null,
  rfidPassword: null,
  error: null,
  loading: false,
  inkTank: { value: "", label: "" },
  inks: inkTextfields,
  machineSerialNumber: ""
};

export const fetchSernums = createAsyncThunk("sernumsSlice/fetchSernums", async (sernum: string, { rejectWithValue, dispatch }) => {
  try {
    const response = await sernumsService.getSernums(sernum);
    console.log(response)
    const updated = response.data.value.map((item) => ({
      "Studio Station" : item.SCO_SERNHASSTUDIO,
      "Foil Saving": item.SCO_SERNHASFOILSAVIN,
      "UV Led": item.SCO_SERNHASHDUVLED,
      "Barcode": item.SCO_SERNHASBARCODE,
      "Art": item.SCO_SERNHASART,
      "Cast&Cure": item.SCO_SERNHASCC,
      "Braille": item.SCO_SERNHASBRAILE,
      "Crystal": item.SCO_SERNHASCRYSTAL,
      "Etherjet 4G": item.SCO_PRESSHASETH4G,
      VPA: item.SCO_SERNHASVPA,
      "Gray Scale": item.SCO_SERNHASGREYSCALE,
      "Uncoated": item.SCO_SERNHASUNCOATED,
      SHD: item.SCO_SERNHASSHD,
      "Multi Layer": item.SCO_SERNHASMULTILAY,
      "3D Sculpture": item.SCO_SERNHAS3DSCULP,
      "Crystal HD": item.SCO_SERNHASCRYSTALHD,
      "Braille HD": item.SCO_SERNHASBRAILEHD,
      "OPA Calib": item.SCO_SERNHASOPACALIB,
      "Curly Sheet": item.SCO_SERNHASCURLYSHET,
      W2PTYPE: item.SCO_SERNW2PTYPE,
      UIPRESSTYPEDES: item.SCO_UIPRESSTYPEDES,
      FOILERTYPE: item.SCO_FOILERTYPE,
      MAAS: item.SCO_MAAS,
      SHBI: item.SCO_HASSHBI,
      "Static Camera": item.SCO_STATICCAMERA,
      "Foiler HMI": item.SCO_SERNHASFOILERHMI,
      MAESTROEMAIL: item.SCO_MAESTROEMAIL,
      MAESTROPASS: item.SCO_MAESTROPASS,
      PRESSTYPEDES: item.SCO_PRESSTYPEDES,
      CAMERATYPE: item.SCO_CAMERATYPE,
      INHOUSEPRESS: item.SCO_INHOUSEPRESS,
      WINID: item.SCO_WINID,
      CDES : item.CDES,
      "Foiler" : item.SCO_FOILER,
      SHIPDATE : item.SHIPDATE,
      Ionizer : item.SCO_PRESSHASIONIZER,
      RFID : item.SCO_PRESSHASRFID,
      FOIL : item.SCO_FOIL,
      W2PWINID : item.SCO_W2PWINID,
      STUDIOID : item.SCO_STUDIOID,
      VMCOUNT : item.SCO_VMCOUNT,
      STORAGEWINID: item.SCO_VMSTORAGEWINID ?? null,
      RIGID: item.SCO_PRESSHASRIGID,
      // CDES : response.data.value[0]
      // PASSGENCOMP: item.SCO_PASSGENCOMP,
      // PASSGENCOMPDATE: item.SCO_PASSGENCOMPDATE
    }));

    const updatedObject = updated.reduce<Record<string, string>>((acc, cur) => {
      Object.keys(cur).forEach((key) => {
        const newKey = key.replace("SCO_SERNHAS", "");
        acc[newKey] = cur[key as keyof typeof cur];
      });
      return acc;
    }, {});

    const findMachineConfiguration = response.data.value.reduce(
      (acc, item) => {
        acc.machineType = item.SCO_UIPRESSTYPEDES ?? "";
        acc.cameraType = item.SCO_CAMERATYPE ?? "";
        acc.w2pType = item.SCO_SERNW2PTYPE ?? "";
        acc.foilerType = item.SCO_FOILERTYPE ?? "";
        return acc;
      },
      { machineType: "", cameraType: "", w2pType:"", foilerType:"" }
    );

    dispatch(setMachineConfig(findMachineConfiguration as MachineConfiguration));

    dispatch(setSernums(updatedObject));

    return response.data;
  } catch (error) {
    const handledError = handleAxiosError(error);
    return rejectWithValue(handledError);
  }
});

export const sendPassword = createAsyncThunk("sernumsSlice/sendPassword", async (password: string, { rejectWithValue, dispatch }) => {
  try {
    const response = await sernumsService.sendPassword(password);

    return response.data;
  } catch (error) {
    const handledError = handleAxiosError(error);
    return rejectWithValue(handledError);
  }
});

export const generatePassword = createAsyncThunk("sernumsSlice/generatePassword", async (someJson: string, { rejectWithValue, dispatch }) => {
  try {
    const response = await sernumsService.generatePassword(someJson);
    dispatch(setEncodedPassword(response.data.encrypt));
    return response.data;
  } catch (error) {
    const handledError = handleAxiosError(error);
    return rejectWithValue(handledError);
  }
});

export const newMachine = createAsyncThunk("sernumsSlice/newMachine", async (someJson: string, { rejectWithValue, dispatch }) => {
  try {
    const response = await sernumsService.newMachine(someJson);
    return response.data;
  } catch (error) {
    window.alert('Initialize machine to BI failed');
    const handledError = handleAxiosError(error);
    return rejectWithValue(handledError);
  }
});

export const generateRfidPassword = createAsyncThunk("sernumsSlice/generateRfidPassword", async (someJson: string, { rejectWithValue, dispatch }) => {
  try {
    const response = await sernumsService.generateRfidPassword(someJson);
    // dispatch(setEncodedPassword(response.data.encrypt));
    dispatch(setRfidPassword(response.data.Token));
    return response.data 
  } catch (error) {
    const handledError = handleAxiosError(error);
    return rejectWithValue(handledError);
  }
});

const sernumsSlice = createSlice({
  name: "sernumsSlice",
  initialState,
  reducers: {
    setSernums: (state, action: PayloadAction<Record<string, string>>) => {
      return {
        ...state,
        sernums: action.payload
      };
    },

    setMachineConfig: (state, action: PayloadAction<MachineConfiguration>) => {
      return {
        ...state,
        machineConfiguration: action.payload
      };
    },

    setEncodedPassword: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        encodedPassword: action.payload
      };
    },

    setRfidPassword: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        rfidPassword: action.payload
      };
    },


    setInkTank: (state, action: PayloadAction<{ value: string; label: string }>) => {
      return {
        ...state,
        inkTank: action.payload
      };
    },

    setInkFields: (state, action: PayloadAction<string[]>) => {
      return {
        ...state,
        inks: state.inks.map((field, index) => {
          if (index === 0) return field;

          const polymerKey = action.payload[index - 1];

          return {
            ...field,
            value: polymerKey || ""
          };
        })
      };
    },

    setMachineSerialNumber: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        machineSerialNumber: action.payload
      };
    }
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchSernums.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSernums.fulfilled, (state) => {
        state.loading = false;
      });
  }
});

export const { setSernums, setMachineConfig, setEncodedPassword,setRfidPassword, setInkTank, setInkFields, setMachineSerialNumber } = sernumsSlice.actions;

export const sernumsState = (state: RootState) => state.sernums.sernums;
export const machineConfigState = (state: RootState) => state.sernums.machineConfiguration;
export const encodedPasswordState = (state: RootState) => state.sernums.encodedPassword;
export const rfidPasswordState = (state:RootState) => state.sernums.rfidPassword;
export const loadingState = (state: RootState) => state.sernums.loading;
export const inkTankState = (state: RootState) => state.sernums.inkTank;
export const inksState = (state: RootState) => state.sernums.inks;
export const machineSerialNumberState = (state: RootState) => state.sernums.machineSerialNumber;

export default sernumsSlice.reducer;
